import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@ppl/ui';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Router } from '@angular/router';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { AccordionComponent } from '@ppl/ui';
import { AuthUtilizationComponent } from "../auth-utilization/auth-utilization.component";
import {  ListTableComponent  } from '@ppl/ui';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '@ppl/ui';
import { AuthFormsComponent } from "../auth-forms/auth-forms.component";
import { PopupDialogComponent } from '@ppl/ui';
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { LookupService } from '../../../../services/lookup.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-add-authorization',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    AccordionComponent,
    AuthFormsComponent,
    PopupDialogComponent
],
  templateUrl: './add-authorization.component.html',
  styleUrl: './add-authorization.component.css',
})
export class AddAuthorizationComponent extends BaseComponent implements OnInit {
  authorizationsForm!: FormGroup;
  radioOptions = RADIO_YES_NO_OPTIONS;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'edit';
  savedData: any = {};
  isNew = true;
  isParticipantSelected = false;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  flow: string|null = '';
  selectedConsumer: any;
  show = false;
  authAdded = false;
  diagnosisCodesList: any;

  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private authorizationService: AuthorizationsDetailsService,
    private userService: UserService,

  ) {
    super();
  }

  ngOnInit(): void {
    this.authorizationsForm = this.fb.group({
        firstName: [[]],
        lastName: [[]],
        medicaid: [[]],
        pplId: [[]],
        plAuthNumber: [[]],
        clientAuthNumber: [[]],
        hcpcsServiceCode: [[]],
        modifier1: [null],
        modifier2: [null],
        modifier3: [null],
        modifier4: [null],
        units: [[]],
        dollars: [[]],
        authStartDate: [[]],
        authEndDate: [[]],
        mcoId: [[]],
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow() ?? '';
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll'
    );
    this.providerTypes = this.getLookup('ProviderType');
    this.getGridHeaders();
  }

  returnClicked() {
    this.router.navigate(['/home/authorizations']);
  }
  
  goBack() {
    this.authorizationService.setDocUpload(false);
    this.authorizationService.clearAddMoreAuth();
    this.authorizationService.clearClonedAuthorization();
    this.router.navigate(['/home/authorizations']);
  }

  authSubmitted(event: any) {
    this.show = true;
    this.authAdded = true;
    this.authorizationService.clearAddMoreAuth();
  }

  onEdit() {
    this.mode = 'edit';
  }

  onConsumerSearch() {
    this.showConsumersList = true;
  }

  uploadDocuments(){
    this.authAdded = true;
    this.show = false;
    this.authorizationService.setDocUpload(true);
  }

  addMoreAuths(){
    this.authAdded = false;
    this.show = false;
    this.authorizationService.setAddMoreAuth(true);
  }

  async getGridHeaders() {
    try {
        if(this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS, this.flow);
        this.cols = tempCols.columns;
        }
    } catch {
      throw new Error(`Failed to get headers`)
    }
  }

  action(event: GridAction) {
    if (event && event.action === 'add') {
        this.selectedConsumer = event.data;
        this.isConsumerSelected = true;
        this.showConsumersList = false;
    }
  }

  onAdd() {
    this.mode = 'read';
  }

  onCancel() {
    this.mode = 'read';
    this.validationErrors = {};
    this.authorizationsForm.reset();
    this.authorizationService.clearAddMoreAuth();
    this.authorizationService.clearAddMoreAuth();
  }

  onUpdate() {
  }

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
    this.isParticipantSelected = true;
  }

  addMore(){
    this.mode = 'edit';
    this.isConsumerSelected = false;
  }
}
